import { motion } from "motion/react";
import { cn } from "@/core/helpers/cn";
import { Icon } from "@/shared/ui";

type Props = {
  className?: string;
};
export default function DeathScreenIcon({ className }: Props) {
  return (
    <motion.div
      initial={{ opacity: 0, translateY: "-100%" }}
      animate={{ opacity: 1, translateY: "none" }}
      transition={{ duration: 0.5, type: "spring" }}
      exit={{ opacity: 0, translateY: "-100%" }}
      className={cn(className)}
    >
      <Icon name="death" className="w-[3rem] bg-[#FF4E4E]" />
    </motion.div>
  );
}
